import services from "../services";
import i18n from "./../i18n";

import isEmpty from "lodash/isEmpty";
import remove from "lodash/remove";

import router from "../router";
import store from "../store";
import Utils from "../Utils";

const strict = true;

const getDefaultState = () => {
  return {
    hfUsers: [],
    toSearch: "",
    multiSelectConfig: {
      //singleSelectConfig
      items: [
        "GESTIONEPROFILI",
        "GESTIONESTRUTTURASANITARIA",
        "RENDICONTAZIONE",
        "GESTIONERICHIESTE",
        "GESTIONERICHIESTE",
        "CENTRONOTIFICHE",
        "CONTATTI"
      ],
      activeItems: []
    },
    sortConfig: {
      list: ["A-Z", "Z-A"],
      order: "A-Z"
    },
    filterCriteriaResults: "",
    operators: [],
    pagination: 1,
    operatorFormData: {
      name: undefined,
      surname: undefined,
      email: undefined,
      permissionsCategories: [
        {
          header: "administration",
          items: [
            {
              portalArea: "GESTIONEPROFILI",
              values: []
            },
            {
              portalArea: "GESTIONESTRUTTURASANITARIA",
              values: []
            },
            {
              portalArea: "RENDICONTAZIONE",
              values: []
            }
          ]
        },
        {
          header: "operations",
          items: [
            {
              portalArea: "GESTIONERICHIESTE",
              values: []
            },
            {
              portalArea: "GESTIONERICHIESTE",
              values: []
            }
          ]
        },
        {
          header: "communication",
          items: [
            {
              portalArea: "CENTRONOTIFICHE",
              values: []
            },
            {
              portalArea: "NEWSTUTORIAL",
              values: []
            },
            {
              portalArea: "FAQ",
              values: []
            },
            {
              portalArea: "CONTATTI",
              values: []
            }
          ]
        }
      ]
    }
  };
};
const state = getDefaultState();

const getters = {
  hfUsers: state => state.hfUsers,
  items: state => state.operators,
  getOperatorById: state => id => {
    return state.operators.find(operator => operator.id == id);
  },
  totalItems: state => state.operators.length,
  toSearch: state => state.toSearch,
  multiSelectFullList: state => state.multiSelectConfig.items,
  multiSelectActiveList: state => state.multiSelectConfig.activeItems,
  orderList: state => state.sortConfig.list,
  order: state => state.sortConfig.order,
  filterCriteriaResults: state => state.filterCriteriaResults,
  activeSortValue: state => `Cognome (${state.sortConfig.order})`,
  pagination: state => state.pagination,
  getUserById: state => id => {
    return state.operators.find(user => user.id == id);
  },
  userName: state => state.operatorFormData.name,
  userSurname: state => state.operatorFormData.surname,
  userEmail: state => state.operatorFormData.email,
  permissionsCategories: state => state.operatorFormData.permissionsCategories,
  getPermissionValue: state => portalArea => {
    state.operatorFormData.permissionsCategories.find(permCategory => {
      let result = permCategory.items.find(
        permission => permission.portalArea == portalArea
      );
      return result.perm;
    });
  }
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SORT_OPERATORS(state) {
    const SORT_ORDER = state.sortConfig.order == "A-Z" ? 1 : -1;

    state.operators.sort(
      (op1, op2) => op1.surname.localeCompare(op2.surname) * SORT_ORDER
    );
  },
  SET_OPERATOR_NAME(state, name) {
    state.operatorFormData.name = name;
  },
  SET_OPERATOR_SURNAME(state, surname) {
    state.operatorFormData.surname = surname;
  },
  SET_OPERATOR_EMAIL(state, email) {
    state.operatorFormData.email = email;
  },
  SET_OPERATOR_PERMISSIONS(state, permissionsCategories) {
    state.operatorFormData.permissionsCategories = permissionsCategories;
  },
  INIT_OPERATOR_PERMISSIONS(state, userpermissions) {
    state.operatorFormData.permissionsCategories.forEach(category => {
      category.items.forEach(permission => {
        let userPermission = userpermissions.find(
          p => p.portalArea == permission.portalArea
        );

        if (!userPermission || userPermission.perm == "NOREAD") return;

        permission.values.push(userPermission.perm);
      });
    });
  },
  SET_TO_SEARCH(state, toSearch) {
    state.toSearch = toSearch;
  },
  SET_MULTI_SELECT_ACTIVE_LIST(state, multiSelectItem) {
    state.multiSelectConfig.activeItems = multiSelectItem;
  },
  removeMultiSelectItem(state, multiSelectItem) {
    let index = state.multiSelectConfig.activeItems.findIndex(
      item => item === multiSelectItem
    );
    state.multiSelectConfig.activeItems.splice(index, 1);
  },
  SET_ORDER(state, order) {
    state.sortConfig.order = order;
  },
  SET_FILTER_CRITERIA_RESULTS(state) {
    let criteria = [];
    if (state.toSearch) {
      criteria.push("'" + state.toSearch + "'");
    }

    let activeMultiSelectItems = state.multiSelectConfig.activeItems;
    if (!isEmpty(activeMultiSelectItems)) {
      let translatedActiveItems = [];
      activeMultiSelectItems.forEach(item => {
        translatedActiveItems.push(
          i18n.t(`baseFilters.operators.${item}Checkbox`).toUpperCase()
        );
      });
      criteria.push("'" + translatedActiveItems.join(", ") + "'");
    }

    state.filterCriteriaResults = criteria.join(" & ");
  },
  SET_OPERATORS(state, operators) {
    state.operators = operators;
  },
  SET_HF_USERS(state, hfUsers) {
    state.hfUsers = hfUsers;
  },
  ADD_NEW_USER(state, user) {
    state.operators.push(user);
  },
  updateUser(state, user) {
    if (
      state.operators != null &&
      Object.keys(state.operators).length !== 0 &&
      user != null &&
      Object.keys(user).length !== 0
    ) {
      let index = state.operators.findIndex(u => u.id === user.id);
      if (index !== -1) {
        state.operators.splice(index, 1, user);
      }
    }
  },
  deleteUser(state, id) {
    remove(state.operators, user => {
      return user.id == id;
    });
  }
};

const actions = {
  getItems({ commit, state }, officeId) {
    let activeFilters = state.multiSelectConfig.activeItems.join(",");
    let reqParams = {
      id: officeId,
      toSearch: state.toSearch,
      toFilter: activeFilters
    };
    services.operatorsManagementService
      .fetchOperators(reqParams)
      .then(operators => {
        commit("SET_FILTER_CRITERIA_RESULTS");
        commit("SET_OPERATORS", operators);
        commit("SORT_OPERATORS");
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          if (error.reason.status == 401) {
            return;
          }
          errorDialogDetails.dataName = "operators";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  getHfUsers({ commit }, params) {
    services.operatorsManagementService
      .fetchHfUsers(params)
      .then(users => {
        commit("SET_HF_USERS", users);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "operators";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  createNewUser({ commit }, { user }) {
    const OFFICE_ID = store.getters["hfManagement/officeId"];
    return services.operatorsManagementService
      .createNewUser(OFFICE_ID, user)
      .then(data => {
        commit("ADD_NEW_USER", user);
        router.push({
          name: "_operators"
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "operators";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  updateUser({ commit }, { user }) {
    const OFFICE_ID = store.getters["hfManagement/officeId"];
    return services.operatorsManagementService
      .updateUser(OFFICE_ID, user)
      .then(data => {
        let loggedInUser = store.getters["auth/userInfo"];
        if (loggedInUser.id == data.id) {
          let newUserInfo = { ...data };
          newUserInfo.permissionList = newUserInfo.permission;
          delete newUserInfo.permission;
          commit("auth/SET_USER_INFO", newUserInfo, { root: true });
        }
        router.push({
          name: "_operators"
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "operators";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(err => {
        console.log(err);
      });
  },
  deleteUser({ commit }, { userId }) {
    const OFFICE_ID = store.getters["hfManagement/officeId"];
    return services.operatorsManagementService
      .deleteUser(OFFICE_ID, userId)
      .then(data => {
        router.push({
          name: "_operators"
        });
      })
      .then(() => {})
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "operators";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      });
  },
  resendUserToken({ commit }, userId) {
    const OFFICE_ID = store.getters["hfManagement/officeId"];
    return services.operatorsManagementService
      .resendUserToken(OFFICE_ID, userId)
      .then(() => {
        let success = {
          title: "operators.resendUserToken.success.title",
          message: "operators.resendUserToken.success.msg",
          closeButtonLabel: "operators.resendUserToken.success.btn",
          closeButtonClb: () => {
            router.push({
              name: "_operators"
            });
          }
        };
        commit("success/openSuccessDialog", success, {
          root: true
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "operators";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(err => {
        console.log(err);
      });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
